import { toValue, watch, type MaybeRefOrGetter } from 'vue'
import { useRoute } from 'vue-router'

// Resets a layout's scroll container to the top whenever the route path
// changes. `html/body/#app` are `overflow: hidden` app-wide, so the window
// never scrolls and the router's `scrollBehavior` has nothing to act on —
// each layout owns its own scroll container and must reset it itself.
//
// Watches `path` only, so query-string updates (filters, sort, tabs synced to
// the URL) keep the investor's current scroll position.
export function useScrollTopOnRouteChange(
  container: MaybeRefOrGetter<HTMLElement | null | undefined>,
) {
  const route = useRoute()

  watch(
    () => route.path,
    () => {
      toValue(container)?.scrollTo({ top: 0, left: 0 })
    },
    { flush: 'post' },
  )
}
